export default {
  inm_session_timeout: 'Session timeout',
  inm_session_timeout_descr: 'Session is about to expire due to long inactivity.'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/inactivity_message.js